import createLucideIcon from '../createLucideIcon';

const Square = createLucideIcon('SquareIcon', [
  [
    'rect',
    {
      x: '3',
      y: '3',
      width: '18',
      height: '18',
      rx: '2',
      ry: '2',
      key: 'maln0c',
    },
  ],
]);

export default Square;
